import { render, staticRenderFns } from "./ActivitySubmission.vue?vue&type=template&id=768db57b"
import script from "./ActivitySubmission.vue?vue&type=script&lang=js"
export * from "./ActivitySubmission.vue?vue&type=script&lang=js"
import style0 from "./ActivitySubmission.vue?vue&type=style&index=0&id=768db57b&prod&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports